import {
  canAccessDashboardPathByContext,
  resolvePolicyIds,
  resolveRoleId,
} from '~/utils/roleAccess'

export default defineNuxtRouteMiddleware((to) => {
  const userStore = useUserStore()
  const roleId = resolveRoleId(userStore.role)
  const policyIds = resolvePolicyIds(userStore.getUser)

  if (canAccessDashboardPathByContext(roleId, policyIds, to.path))
    return

  return navigateTo('/volontaires')
})
